import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-barra-busca',
  templateUrl: './barra-busca.component.html',
  styleUrls: ['./barra-busca.component.scss'],
})
export class BarraBuscaComponent implements OnInit {
  /* tslint:disable-next-line:no-input-rename */
  @Input('componenteRef') componenteAtual: string;
  @Input() eixos?: any[];
  searchString: any;

  ordenarPor = [
    { id: 'asc', nome: 'Ordem Alfabética (A - Z)' },
    { id: 'desc', nome: 'Ordem Alfabética (Z - A)' },
  ];

  filtrarPor = [
    { id: 'vigentes', nome: 'Cursos vigentes' },
    { id: 'mudaramnome', nome: 'Possível Convergência' },
    { id: 'naopermitidos', nome: 'Cursos excluídos ou não incluídos' },
    // { id: 'experimentais', nome: 'Cursos em oferta experimental' },
  ];

  toggle = false;
  formularioPesquisa: FormGroup;
  filtroPadrao: string;
  eixo: string | number;

  @Output() inputEvent = new EventEmitter<any>();

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((q) => {
      this.searchString = q.query ? q.query : '';
      this.filtroPadrao = q.filtro ? q.filtro : 'vigentes';
      this.eixo = q.eixo ? q.eixo : '';
    });

    this.formularioPesquisa = new FormGroup({
      stringBusca: new FormControl(this.searchString),
      ordenacao: new FormControl('asc'),
      filtro: new FormControl(this.filtroPadrao),
      eixo: new FormControl(+this.eixo),
    });
  }

  onPesquisar() {
    this.toggle = this.toggle ? !this.toggle : this.toggle;
    const { stringBusca, ordenacao, eixo, filtro } =
      this.formularioPesquisa.value;
    this.inputEvent.emit([stringBusca, ordenacao, eixo, filtro]);
  }
}
